// extracted by mini-css-extract-plugin
export var csatScore = "_lb-5";
export var header = "_lb-1";
export var panelWrapper = "_lb-2";
export var postPreview = "_lb-3";
export var rightContent = "_lb-0";
export var wrappingText = "_lb-4";